import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    types: null,
    categories: null,
    searchQuery: '',
    profileCategory: null,
    relatedSpeakers: null,
    sortOrder: null,
  },
}

export const speakersSlice = createSlice({
  name: 'speakers',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload
    },
  },
})

// Selectors
export const getFilters = (state) => state.speakers.filters

// Action creators are generated for each case reducer function
export const { setFilters } = speakersSlice.actions

export default speakersSlice.reducer
